<template>
	<div>
		<van-popup round v-model:show="show" :style="{ padding: '0 15px 15px',width: '200px' }">
			<h2 style="font-size: 20px;line-height: 40px;">温馨提示</h2>
			<p style="font-size: 14px; line-height:28px; text-indent:2em;">您还未填写手机号，为了您更好的体验，请立即前往！</p>
			<van-row justify="space-between">
				<van-col span="8" style="text-align: center; margin: 10px 0 0;"><van-button type="default"
						style="font-size:12px" @click="cancel">以后再说</van-button></van-col>
				<van-col span="8">
					<div style="width: 100%; height:1px;"></div>
				</van-col>
				<van-col span="8" style="text-align: center; margin: 10px 0 0;"><van-button type="primary"
						style="font-size:12px" @click="ok">立即填写</van-button></van-col>
			</van-row>
		</van-popup>
	</div>
</template>

<script>
	import {
		Toast,
		showConfirmDialog
	} from 'vant'
	import axios from 'axios'
	import {
		reqPwdLogin,
		getUserInfo,
		isHavePhone
	} from '../../api'
	import { tokenReady } from '../../api/axios'
	/**
	 * 微信网页授权
	 */
	export default {
		name: 'auth',
		data() {
			return {
				show: false,
				target: '',
				companyId: ''
			}
		},
		async created() {
			this.companyId = this.$route.params.companyId
			console.log('[Auth] 页面加载, companyId:', this.companyId, 'code:', this.$route.query.code)
			console.log('[Auth] 当前cookie:', document.cookie)
			// 如果连接中有微信返回的 code，则用此 code 调用后端接口，向微信服务器请求用户信息
			// 如果不是从微信重定向过来的，没有带着微信的 code，则直接进入首页
			if (this.$route.query.code) {
				await tokenReady
				const MpappId = params => {
					return axios.get('/api/common/weixin/' + params.companyId + '/' + params.code)
						.then(res => res.data);
				};
				let params = {
					companyId: this.companyId,
					code: this.$route.query.code
				}
				this.target = this.$cookies.get('t');
				if (!this.target) {
					this.target = "payment";
				} else {
					if ("1" == this.target) {
						this.target = "payment";
					} else if ("2" == this.target) {
						this.target = "reportrepair";
					} else if ("3" == this.target) {
						this.target = "choujiang";
					}
				}
				MpappId(params).then(res => {
					console.log('[Auth] 微信用户信息接口返回:', JSON.stringify(res))
					if (res.success) {
						this.$cookies.set('wxUserInfo', res)
						console.log('[Auth] wxUserInfo写入后cookie:', document.cookie.indexOf('wxUserInfo='))
						localStorage.setItem('wxUserInfo', JSON.stringify(res))
						this.voluntarilyLogin(res.openid)
					} else {
						alert(res.msg);
					}
				}).catch(error => {
					console.log('[Auth] 微信用户信息接口异常:', error)
					alert(error.msg);
				});
			} else {
				this.$router.push({
					name: 'wxauth',
					params: { companyId: this.companyId }
				})
			}
		},
		methods: {
			//openId已注册的情况下直接用openId登录
			voluntarilyLogin(openid) {
				console.log('[Auth] voluntarilyLogin, openid:', openid)
				if (!openid) {
					console.log('[Auth] openid为空 → 跳转wxauth')
					this.$router.push({
						name: 'wxauth',
						params: { companyId: this.companyId }
					})
					return false
				}
				let data = {
					openId: openid
				}
				getUserInfo(data).then(res => {
					console.log('[Auth] getUserInfo返回:', JSON.stringify(res))
					if (res.code == 200) {
						Toast.success({
							message: '登录成功！',
							className: 'apiLoading'
						});
						this.$cookies.remove('userInfo');
						this.$cookies.set('userInfo', res.data);
						console.log('[Auth] userInfo写入后cookie:', document.cookie.indexOf('userInfo='))
						this.isSavePhone(res.data)

					} else {
						console.log('[Auth] getUserInfo code!=' + res.code + ' → 跳转wxauth')
						this.$router.push({
							name: 'wxauth',
							params: { companyId: this.companyId }
						})
					}
				}).catch(error => {
					console.log('[Auth] getUserInfo异常:', error)
				})
			},
			isSavePhone(userInfo) {
				isHavePhone({
					userId: userInfo.userId
				}).then(res => {
					console.log('[Auth] isHavePhone返回:', JSON.stringify(res), '→ target:', this.target)
					if (res.data) {
						this.$router.push({
							name: this.target,
							params: { companyId: this.companyId }
						})
					} else {
						this.show = true
					}
				})
			},
			cancel() {
				this.show = false
				this.$router.push({
					name: this.target,
					params: { companyId: this.companyId }
				})
			},
			ok() {
				this.show = false
				this.$router.push({
					name: 'updatephone',
					params: { companyId: this.companyId }
				})
			}
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus">

</style>



// WEBPACK FOOTER //
// src/pages/Wxauth/Auth.vue